import styled from 'styled-components';
import { PrimaryButton } from '../../styles/sharedComponents';

export const PricingSection = styled.section<{ $isVisible?: boolean }>`
  padding: 120px 20px;
  background: linear-gradient(180deg, #0a0a0a 0%, #0a0a0a 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(180deg, transparent 0%, rgba(10, 10, 10, 0.2) 20%, rgba(10, 10, 10, 0.5) 40%, rgba(10, 10, 10, 0.8) 70%, rgba(10, 10, 10, 1) 100%);
    pointer-events: none;
    z-index: 1;
  }

  @media (max-width: 768px) {
    padding: 60px 16px;
  }
`;

export const PricingGrid = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
  padding: 0 16px;

  @media (max-width: 1100px) {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  @media (max-width: 768px) {
    gap: 20px;
    padding: 0 12px;
  }
`;

export const PricingCardContainer = styled.div<{ $featured?: boolean }>`
  background: ${props => props.$featured
    ? 'linear-gradient(135deg, rgba(255, 68, 68, 0.08), rgba(255, 68, 68, 0.02))'
    : 'rgba(255, 255, 255, 0.02)'};
  border: 1px solid ${props => props.$featured
    ? 'rgba(255, 68, 68, 0.2)'
    : 'rgba(255, 255, 255, 0.06)'};
  border-radius: ${props => props.theme.borders.radius.xl};
  padding: 40px;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 0 0 320px;
  min-width: 300px;
  height: 850px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    border-color: ${props => props.$featured
    ? 'rgba(255, 68, 68, 0.4)'
    : 'rgba(255, 255, 255, 0.12)'};
    transform: scale(1.02);
  }

  @media (max-width: 1100px) {
    flex: none;
    width: 100%;
    max-width: 400px;
    height: 820px;
    transform: translateY(0) scale(1);
  }

  @media (max-width: 768px) {
    padding: 24px 20px;
    height: auto;
    min-height: 700px;
    max-width: 100%;
  }
`;

export const PricingBadge = styled.div`
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #ff4444, #ff2222);
  color: white;
  padding: 6px 16px;
  border-radius: ${props => props.theme.borders.radius.md};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 11px;
    padding: 5px 12px;
  }
`;

export const PricingHeader = styled.div`
  text-align: center;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const PricingName = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 12px;
  color: #fafafa;

  @media (max-width: 768px) {
    font-size: 18px;
    margin: 0 0 8px;
  }
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const OldPrice = styled.div`
  font-size: 16px;
  color: #71717a;
  text-decoration: line-through;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const NewPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

export const PriceCurrencyTag = styled.span`
  font-size: 11px;
  letter-spacing: 0.14em;
  color: #a1a1aa;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const PriceMainValue = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  color: #fafafa;
  line-height: 1;
`;

export const PriceSymbol = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #fafafa;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const PriceNumber = styled.span`
  font-size: 42px;
  font-weight: 700;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const PriceSuffix = styled.span`
  font-size: 14px;
  color: #71717a;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const DiscountBadge = styled.div`
  display: inline-block;
  background: linear-gradient(135deg, #ff4444, #ff2222);
  color: white;
  padding: 4px 12px;
  border-radius: ${props => props.theme.borders.radius.base};
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 6px;

  @media (max-width: 768px) {
    font-size: 10px;
    padding: 3px 10px;
  }
`;

export const InstallmentInfo = styled.div`
  font-size: 13px;
  color: #a1a1aa;
  margin-top: 8px;
  text-align: center;

  span {
    color: #fafafa;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    font-size: 11px;
    margin-top: 6px;
  }
`;

export const InstallmentMain = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  justify-content: center;
`;

export const InstallmentPrefix = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #fafafa;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const UrgencyBadge = styled.div`
  background: rgba(255, 68, 68, 0.1);
  border: 1px solid rgba(255, 68, 68, 0.3);
  color: #ff4444;
  padding: 8px 12px;
  border-radius: ${props => props.theme.borders.radius.base};
  font-size: 12px;
  font-weight: 600;
  margin-top: 16px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 42px;

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    font-size: 10px;
    padding: 6px 10px;
    margin-top: 12px;
    white-space: normal;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

export const FeatureBadge = styled.div`
  background: rgba(255, 68, 68, 0.1);
  border: 1px solid rgba(255, 68, 68, 0.2);
  color: #ff4444;
  padding: 4px 10px;
  border-radius: ${props => props.theme.borders.radius.base};
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;

  svg {
    width: 12px;
    height: 12px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
    padding: 3px 8px;

    svg {
      width: 10px;
      height: 10px;
    }
  }
`;

export const PricingFeatures = styled.ul`
  list-style: none;
  padding: 0;
  margin: 24px 0;
  flex-grow: 1;

  @media (max-width: 768px) {
    margin: 16px 0;
  }
`;

export const PricingFeature = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  color: #a1a1aa;
  font-size: 15px;

  &::before {
    content: '✓';
    color: #22c55e;
    font-weight: 600;
    font-size: 16px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px 0;
    gap: 8px;

    &::before {
      font-size: 14px;
    }
  }
`;

export const PricingButton = styled(PrimaryButton) <{ $variant?: 'secondary' }>`
  width: 100%;
  background: ${props => props.$variant === 'secondary'
    ? 'transparent'
    : 'linear-gradient(135deg, #ff4444, #ff2222)'};
  border: ${props => props.$variant === 'secondary'
    ? '1px solid rgba(255, 255, 255, 0.12)'
    : 'none'};
  color: ${props => props.$variant === 'secondary' ? '#a1a1aa' : 'white'};
  margin-top: auto;

  &:hover {
    background: ${props => props.$variant === 'secondary'
    ? 'rgba(255, 255, 255, 0.06)'
    : 'linear-gradient(135deg, #ff5555, #ff3333)'};
  }

  @media (max-width: 768px) {
    padding: 14px 24px;
    font-size: 14px;
  }
`;
